import Table from './src/table';

Table.install = function(Vue) {
  Vue.component(Table.name, Table);
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/table/index.js